export enum TagCategoryEnum {
  PERIOD = "period",
  TRAINING_TAG = "training_tag",
  SESSION_TAG = "session_tag",
}

export enum VisibleItemsStyleEnum {
  CHIP = "chip",
  ICON_CHIP = "icon_chip",
  TEXT = "text",
  MEDIUM_TEXT = "medium_text",
  AVATAR_TEXT = "avatar_text",
}
